import React from "react";
import { Link } from "react-router-dom";

import pohori_1 from "../../public/pohori_jeseniky/pohori_1.png";
import pohori_2 from "../../public/pohori_jeseniky/pohori_2.png";
import pohori_3 from "../../public/pohori_jeseniky/pohori_3.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Jeseniky = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? "pohori dark" : "pohori light"}>
        <div className="container">
          <div className="pohori-container">
            <div className="pohori-image">
              <img src={pohori_1} alt="" />
            </div>
            <div className="pohori-content">
              <h1 className={darkMode ? "dark-text" : "light-text"}>
                Jeseníky
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "pohori-trip dark" : "pohori-trip light"}>
        <div className="container">
          <div className="pohori-trip-container">
            <div className="pohori-trip-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Kam se vydat v Jeseníkách?
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Jeseníky vám nabízejí celou řadu outdoorových aktivit, které
                můžete prozkoumat. Ať už hledáte horská kola, pěší turistiku,
                nebo třeba rafting, na výběr je spousta aktivit. Pro ty, kteří
                chtějí spíše odpočívat, je zde mnoho malebných rozhleden, které
                nabízejí úchvatné výhledy. Můžete se vydat na túru po
                nejkrásnější přírodě, lesích a kopcích a nasát atmosféru, kterou
                tyto hory nabízejí.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : ""}
                to="/jeseniky/kamsevydat"
              >
                <span>Více</span>
              </Link>
            </div>
            <div className="pohori-trip-image">
              <img src={pohori_2} alt="" />
            </div>
          </div>
        </div>
      </section>

      <section
        className={darkMode ? "pohori-nature dark" : "pohori-nature light"}
      >
        <div className="container">
          <div className="pohori-nature-container">
            <div className="pohori-nature-image">
              <img src={pohori_3} alt="" />
            </div>
            <div className="pohori-nature-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Příroda v Jeseníkách
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                CHKO Beskydy je svou rozlohou 1 160 km² největší chráněnou
                krajinnou oblastí v České republice. Naleznete zde původní
                pralesovité porosty, horské louky s výskytem vzácných
                karpatských rostlin a živočichů i unikátní pseudokrasové jevy.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Jeseniky;
